import React from "react";
import Logo from "@/components/Logo";

/**
 * Premium loading screen — calm fade-in + 95% → 100% scale of the brand mark.
 * Total animation duration ~1.2s.
 */
export default function LoadingScreen({ label = "" }) {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-ag-paper ag-paper-grain"
      data-testid="loading-screen"
    >
      <div className="flex flex-col items-center gap-5">
        <Logo
          variant="full"
          tone="light"
          className="ag-logo-enter h-16 md:h-20 w-auto"
        />
        {label ? (
          <div className="ag-claim-enter text-xs uppercase tracking-[0.28em] text-slate-400">
            {label}
          </div>
        ) : null}
      </div>
    </div>
  );
}
